var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyOption = function SvgKeyOption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_70275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 29.934,
    height: 26.94,
    rx: 1.796,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63195 17.3965C8.63221 17.3965 8.07797 18.1227 8.07797 19.1084V19.4697C8.07797 20.4589 8.6287 21.1885 9.63195 21.1885C10.6352 21.1885 11.1824 20.4589 11.1824 19.4697V19.1084C11.1824 18.1227 10.6282 17.3965 9.63195 17.3965ZM9.63195 17.8491C10.2844 17.8491 10.6668 18.3366 10.6668 19.1329V19.4416C10.6668 20.2414 10.2844 20.729 9.63195 20.729C8.97598 20.729 8.59363 20.2379 8.59363 19.4416V19.1329C8.59363 18.3366 8.97598 17.8491 9.63195 17.8491ZM13.7432 21.1885C14.5956 21.1885 15.2095 20.5501 15.2095 19.4837V19.1014C15.2095 18.0315 14.5921 17.3965 13.7677 17.3965C13.238 17.3965 12.8662 17.6737 12.6627 18.0034H12.6487V17.4562H12.1611V22.4023H12.6733V20.6168H12.6873C12.8873 20.936 13.2451 21.1885 13.7432 21.1885ZM13.7221 20.729C13.0626 20.729 12.6663 20.2063 12.6663 19.4346V19.1189C12.6663 18.3787 13.0556 17.8491 13.7081 17.8491C14.322 17.8491 14.6938 18.3226 14.6938 19.1224V19.4346C14.6938 20.28 14.2939 20.729 13.7221 20.729ZM16.3916 17.4562H15.89V17.8947H16.3916V20.1257C16.3916 20.8342 16.553 21.164 17.3914 21.164C17.5141 21.164 17.6369 21.15 17.6895 21.1394V20.715C17.6369 20.722 17.5843 20.722 17.5211 20.722C17.0546 20.722 16.9073 20.6097 16.9073 20.1572V17.8947H17.6579V17.4562H16.9073V16.5336H16.3916V17.4562ZM18.6296 21.1289H19.1453V17.4562H18.6296V21.1289ZM18.5384 16.5617C18.5384 16.7581 18.6963 16.916 18.8857 16.916C19.0821 16.916 19.24 16.7581 19.24 16.5617C19.24 16.3687 19.0821 16.2109 18.8857 16.2109C18.6963 16.2109 18.5384 16.3687 18.5384 16.5617ZM21.699 17.3965C20.6993 17.3965 20.145 18.1227 20.145 19.1084V19.4697C20.145 20.4589 20.6958 21.1885 21.699 21.1885C22.7023 21.1885 23.2495 20.4589 23.2495 19.4697V19.1084C23.2495 18.1227 22.6952 17.3965 21.699 17.3965ZM21.699 17.8491C22.3515 17.8491 22.7338 18.3366 22.7338 19.1329V19.4416C22.7338 20.2414 22.3515 20.729 21.699 20.729C21.043 20.729 20.6607 20.2379 20.6607 19.4416V19.1329C20.6607 18.3366 21.043 17.8491 21.699 17.8491ZM24.2177 21.1289H24.7333V18.8804C24.7333 18.3542 25.021 17.8701 25.6945 17.8701C26.2698 17.8701 26.6381 18.2174 26.6381 18.8453V21.1289H27.1537V18.7681C27.1537 17.8771 26.589 17.3965 25.8313 17.3965C25.2279 17.3965 24.8841 17.7122 24.7473 17.9578H24.7333V17.4562H24.2177V21.1289Z",
    fill: "#212B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.66 8.76759H27.4345V8.25751H25.854L23.5623 5.83647H21.7878V6.34654H23.3683L25.66 8.76759ZM25.66 6.34654H27.4345V5.83647H25.66V6.34654Z",
    fill: "#212B36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 0.15,
    width: 29.634,
    height: 26.641,
    rx: 1.646,
    stroke: "#212B36",
    strokeWidth: 0.299
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_70275",
    x: 0.401,
    y: 0,
    width: 31.131,
    height: 28.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.599,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_4723_70275"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_70275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4723_70275",
    result: "shape"
  })))));
};
export default SvgKeyOption;